import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import OrbLoader from "../common/OrbLoader";
import { ClientPage } from "./ClientUiViewClient";

// Pantallas de espera, error y "no hay nada", con el mismo aire que el resto.

export const ClientLoading: React.FC = () => {
  const { t } = useTranslation();
  return (
    <ClientPage>
      <Box
        sx={{
          minHeight: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <OrbLoader size="large" label={t("clientView.loading")} />
      </Box>
    </ClientPage>
  );
};

export const ClientMessage: React.FC<{
  title: string;
  message?: string;
  action?: { label: string; onClick?: () => void; to?: string };
  children?: React.ReactNode;
}> = ({ title, message, action, children }) => {
  const navigate = useNavigate();
  return (
    <ClientPage>
      <Box
        sx={{
          minHeight: "60vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          gap: 2,
          maxWidth: 460,
          mx: "auto",
        }}
      >
        <Typography component="h1" sx={{ fontSize: 26, fontWeight: 700 }}>
          {title}
        </Typography>
        {message && (
          <Typography sx={{ fontSize: 16, color: "text.secondary" }}>
            {message}
          </Typography>
        )}
        {children}
        {action && (
          <Button
            variant="contained"
            disableElevation
            onClick={() =>
              action.to ? navigate(action.to) : action.onClick?.()
            }
            sx={{
              mt: 2,
              borderRadius: 999,
              textTransform: "none",
              fontWeight: 700,
              px: 4,
              py: 1.25,
            }}
          >
            {action.label}
          </Button>
        )}
      </Box>
    </ClientPage>
  );
};

/** Error de carga con botón para reintentar. */
export const ClientError: React.FC<{ onRetry: () => void }> = ({ onRetry }) => {
  const { t } = useTranslation();
  return (
    <ClientMessage
      title={t("clientView.error.title")}
      message={t("clientView.error.message")}
      action={{ label: t("clientView.error.retry"), onClick: onRetry }}
    />
  );
};
